import { Controller } from "@hotwired/stimulus"

// Budget card skins are a per-device choice: one localStorage key per
// budget, written by budget_skin_picker_controller on Edit budget.
export const SKIN_KEY_PREFIX = "budget-skin:"
// Stored when the user picks the plain tile, so a Needs / Wants card stays
// plain instead of falling back to its default background.
export const SKIN_NONE = "none"

// On the dashboard's card stage. Every budget renders a card here, so a
// skin key with no card belongs to a deleted budget and is dropped; the
// rest are put on their cards as data-skin (styles in application.css).
export default class extends Controller {
  connect() {
    const cards = this.element.querySelectorAll("[data-budget-skin-id]")
    const ids = new Set(Array.from(cards, card => card.dataset.budgetSkinId))

    try {
      Object.keys(localStorage)
        .filter(key => key.startsWith(SKIN_KEY_PREFIX) && !ids.has(key.slice(SKIN_KEY_PREFIX.length)))
        .forEach(key => localStorage.removeItem(key))

      cards.forEach(card => {
        const stored = localStorage.getItem(SKIN_KEY_PREFIX + card.dataset.budgetSkinId)
        const skin = stored === SKIN_NONE ? "" : (stored || card.dataset.budgetDefaultSkin)
        if (skin) card.dataset.skin = skin
        else delete card.dataset.skin
      })
      this.#dressPeeks(Array.from(cards))
    } catch (error) {
      // Storage blocked: every card keeps the default surface.
      console.warn("Budget skins unavailable:", error)
    }
  }

  // The neighbour peeks each card carries (budgets/_budget_card) wear the
  // neighbour's skin: the card before for the start-side sliver, the card
  // after for the end-side one. .budget-skin-surface paints the sliver with
  // the same material the card wears; with no skin it stays the plain
  // surface. Cards come in carousel order.
  #dressPeeks(cards) {
    const dress = (peek, neighbour) => {
      if (!peek) return
      const skin = neighbour?.dataset.skin
      peek.classList.toggle("budget-skin-surface", Boolean(skin))
      if (skin) peek.dataset.skin = skin
      else delete peek.dataset.skin
    }

    cards.forEach((card, i) => {
      dress(card.querySelector(".budget-peek-prev"), cards[i - 1])
      dress(card.querySelector(".budget-peek-next"), cards[i + 1])
    })
  }
}
